import React, { useState, useEffect, useRef } from 'react';

// import Header from './Header';
// import Sidebar from './Sidebar';
// import CandidateTab from './CandidateTab';
// import NotificationPanels from './NotificationPanels';
import MainFormOnbording from './MainFormOnbording';
import NotificationPanels from '../NotificationPanels';
import ClientHeader from '../Partials/ClientHeader';
import ClientSideBar from '../Partials/ClientSideBar';
import Header from '../Header';
import Sidebar from '../Sidebar';
import CandidateTab from '../CandidateTab';
import StepCount from '../Common/StepCount';
import Footer from '../Footer';
import { useDispatch, useSelector} from 'react-redux';
import { getOnboardingDetails } from '../../Actions/onboardingDetailsAction';
import ProgressHeading from '../Common/ProgressHeading';
// import StepCount from './Common/StepCount';
// import ClientSideBar from './Partials/ClientSideBar';
// import ClientHeader from './Partials/ClientHeader';

const OnbordingDetailsInstaform = () => {
    const form = useRef();
    const [role, setRole] = useState();
    const [onboarding, setOnboarding]= useState({});
    const dispatch=useDispatch();
    useEffect(()=>{
        const fetchData=async()=>{
            dispatch(getOnboardingDetails());
        }
        fetchData();
    },[]);

    const autoLoginStore = useSelector((state) => state.autoLogin);
    const { autoLoginData, loadingLogin } = autoLoginStore;
  
    useEffect(() => {
      if (
        typeof autoLoginData?.status !== "undefined" &&
        autoLoginData?.status !== null
      ) {
        
       setRole(autoLoginData.data.user_role);
      }
    }, [autoLoginData, autoLoginStore]);

    return (
        <>
            <NotificationPanels />
            {role === "EP" ? <ClientHeader /> : <Header />}
            {role === "EP" ? <ClientSideBar /> : <Sidebar />}
            <section className="main-section candidate-tab-form" style={{ paddingTop: '60px' }}>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-auto w-100-mbl bg-gray-mbl">
                            <ProgressHeading/>
                            <CandidateTab activeTab={"Onboarding Details"} />
                        </div>
                        <div className="col bg-gray-mbl">
                            {/*Form*/}

                            <form ref={form} className="p-3 form2 form-section">
                                <StepCount activeTab={"onboardingDetails"} />
                                <MainFormOnbording  />
                            </form>

                            {/*Form*/}
                            {/* <div className="mt-4">
                                <div className="row mb-3">
                                    <div className="col-md-12 d-flex align-items-center btn-and-info-responsive">
                                        <button className="btn btn-primary btn-lg mr-3">Submit for Preview</button>
                                        <span className="text-muted">Please complete the all mandatory fields before final submission</span>
                                    </div>
                                </div>
                            </div> */}
                            <Footer />
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default OnbordingDetailsInstaform;
